import { motion } from "motion/react";
import classNames from "classnames";
import { useProductWithCockpitId } from "../../hooks/ProductHooks";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { transformHtml } from "../../utils/CmsUtils";
import { unwrapAsset } from "../../utils/CockpitUtils";
import ImageOrVideo from "../ImageOrVideo";
import GuideProductInfo from "./GuideProductInfo";
import "./style.scss";
import Icon from "../Icon";

const GuideStepCard = ({
  type = "normal",
  image,
  animation,
  product_link,
  label,
  description,
  index = 1,
  basePath = "",
  fullWidth = false,
  onClick = () => {}
}) => {
  const t = useBjelinTranslations();

  const product = useProductWithCockpitId(product_link?._id);

  //if (product) console.log("product", product);

  return (
    <motion.div
      className={classNames("guide-step", {
        "guide-step-card": !fullWidth,
        "guide-step-full-width": fullWidth,
        "guide-step-product": type === "product" && product
      })}
    >
      <div
        className={classNames("guide-step-inner", {
          "has-image": image || product,
          "has-description": description
        })}
        onClick={e => {
          onClick(e);
          e.preventDefault();
          return false;
        }}
      >
        {type === "product" && product ? (
          <motion.div
            className="guide-image"
            style={{
              backgroundColor: "#ddd"
            }}
          >
            <div className={"image-container"}>
              <img
                src={product.images?.[0].styles.preview}
                alt={product.name}
                style={{
                  display: "block",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "100%",
                  width: "100%",
                  objectFit: "cover"
                }}
              />
            </div>
          </motion.div>
        ) : (
          image && (
            <motion.div
              className="guide-image"
              style={{
                backgroundColor: image.colors && image.colors[0]
              }}
            >
              <ImageOrVideo
                image={unwrapAsset(image)}
                style={{
                  width: "100%"
                }}
              />
            </motion.div>
          )
        )}
        <div
          className={classNames("guide-text", {
            "without-image": !image && !product,
            "has-description": description
          })}
        >
          {!fullWidth && type !== "product" ? (
            <motion.h3>
              <span className="index-number">{index}</span>
              {label ? label : t("guide.no-label")}
            </motion.h3>
          ) : (
            <motion.h3
              className={classNames({ "no-label": !label && !product })}
            >
              {label ? label : product ? product.name : t("guide.no-label")}
            </motion.h3>
          )}
          {type === "product" && product && (
            <GuideProductInfo product={product} />
          )}
          {!product && description && (
            <div className="guide-description">
              {transformHtml(description)}
            </div>
          )}
        </div>
      </div>
      <div className="guide-step-hover">
        <Icon name="play" type="fas" />
      </div>
    </motion.div>
  );
};

export default GuideStepCard;
